<nav class="relative bg-white select-none" (clickOutside)="close()" (mouseleave)="isOpen.set(false)">
    <div class="w-fll bg-white *:bg-white">
        <div id="main_header" class="flex items-center justify-between px-4 md:px-3 py-4 bg-white mx-auto container max-w-[1280px]">
            <img
                [draggable]="false"
                class="w-24 h-full transition-all duration-300 cursor-pointer md:h-full md:w-36 hover:opacity-70"
                routerLink="/"
                src="logo.svg"
            />
            @defer {
                @if (!user()) {
                    <div class="items-center justify-center hidden gap-3 md:flex">
                        <div class="flex self-center justify-center w-16">
                            <a routerLink="/login" class="font-normal text-gray-600 transition-all cursor-pointer hover:text-primary"
                                >로그인</a
                            >
                        </div>
                        <app-button size="md" routerLink="/sign-up">
                            <span class="font-normal"> 회원가입 </span>
                        </app-button>
                    </div>
                } @else {
                    <div class="items-center justify-center hidden gap-2 md:gap-4 md:flex md:group">
                        <div class="flex items-center justify-center gap-1 cursor-pointer w-fit group">
                            <a (click)="logout()" class="font-normal text-gray-600 transition-all group-hover:text-primary">로그아웃</a>
                            <lepi-icon
                                name="solar:login-2-line-duotone"
                                class="block transition-all bg-gray-600 size-5 group-hover:bg-primary"
                            />
                        </div>
                        <div
                            routerLink="/my-page"
                            class="flex items-center justify-center gap-1 break-all transition-all cursor-pointer w-fit group"
                        >
                            <p class="font-normal text-gray-600 group-hover:text-primary">마이페이지</p>
                            <lepi-icon name="solar:user-bold-duotone" class="block bg-gray-600 size-5 group-hover:bg-primary" />
                        </div>

                        <div
                            routerLink="/customer"
                            class="flex items-center justify-center gap-1 break-all transition-all cursor-pointer w-fit group"
                        >
                            <p class="font-normal text-gray-600 group-hover:text-primary">고객센터</p>
                            <lepi-icon name="solar:phone-bold-duotone" class="block bg-gray-600 size-5 group-hover:bg-primary" />
                        </div>
                    </div>
                }
            }
            <lepi-icon (click)="sidebar()" class="block bg-gray-600 cursor-pointer size-7 md:hidden" name="ic:round-view-headline" />
        </div>
    </div>

    <div class="hidden border-b md:block"></div>

    <div
        id="category_header"
        class="flex px-4 md:px-3 items-center bg-white md:mx-auto md:container md:max-w-[1280px] overflow-x-auto overflow-hidden"
    >
        <div class="flex md:flex-1 min-w-fit break-keep shrink-0">
            <div class="flex items-center justify-center gap-3 cursor-pointer md:group">
                @for (category of topLevelCategoryList(); track category.id) {
                    <p
                        (mouseenter)="isOpen.set(true)"
                        class="px-1 py-4 border-b-2 hover:text-primary min-w-max"
                        [ngClass]="category.id == headerCategory() ? 'text-primary border-primary ' : 'text-black border-transparent'"
                        (click)="moveTo(category)"
                    >
                        {{ category.name }}
                    </p>
                }
            </div>
        </div>

        <div class="md:flex *:flex md:flex-1 justify-end min-w-fit break-keep shrink-0 hidden pl-10 lg:pl-0">
            <div class="flex items-center justify-center gap-6 cursor-pointer md:group">
                <!-- QA 마무리 되면 삭제 예정 -->
                <!-- <p class="hover:text-primary" routerLinkActive="text-primary " routerLink="/gallery">갤러리</p> -->
                @if (!user()) {
                    <p class="hover:text-primary" routerLinkActive="text-primary " routerLink="/magazine">매거진</p>
                } @else {
                    @for (menu of subMenuList(); track $index) {
                        <p class="hover:text-primary" routerLinkActive="text-primary " [routerLink]="menu.key">
                            {{ menu.value }}
                        </p>
                    }
                }
            </div>
        </div>
    </div>

    <div id="main_header" class="w-full border-b"></div>
    <!-- desktop dropdown -->
    <div
        #dropdown
        [ngClass]="{ 'shadow-sm': isOpen() }"
        [ngStyle]="{
            maxHeight: isOpen() ? dropdownHeight() : '0px',
        }"
        class="md:absolute hidden left-0 w-full md:flex overflow-hidden transition-all duration-300 bg-white z-[9999]"
    >
        <div class="flex *:cursor-pointer text-neutral-500 w-full p-4 md:mx-auto md:container md:max-w-[1280px]">
            <div class="grid w-full grid-cols-3 gap-6 pt-6">
                @for (category of topLevelCategoryList(); track category.id) {
                    <div class="relative flex flex-col flex-1 w-full gap-2.5">
                        <div class="flex items-center gap-2 div-hover-effect">
                            <lepi-icon
                                class="block transition-all bg-gray-500 size-5 hover:bg-primary"
                                name="solar:map-point-bold-duotone"
                            />
                            <p
                                [routerLink]="['/product']"
                                [queryParams]="{
                                    category: category.id,
                                }"
                                routerLinkActive="text-primary"
                                class="font-bold text-gray-800 transition-all hover:text-primary"
                            >
                                {{ category.name }}
                            </p>
                        </div>
                        <div class="w-full border-b-2 border-gray-800"></div>
                        <div class="flex flex-col pb-6">
                            <div class="grid grid-cols-2">
                                <div
                                    routerLink="/product"
                                    [queryParams]="{
                                        category: category.id,
                                    }"
                                    class="flex items-center transition-all rounded-xl py-2.5 px-3 text-gray-800 hover:bg-primary-50 hover:text-primary-500 hover:font-bold"
                                >
                                    전체
                                </div>
                                @for (i of category.children; track i.id) {
                                    <div
                                        [routerLink]="['/product/category', i.id]"
                                        [queryParams]="{
                                            children: 'all',
                                            parent: category?.id,
                                        }"
                                        class="flex transition-all items-center rounded-xl py-2.5 px-3 text-gray-800 hover:bg-primary-50 hover:text-primary-500 hover:font-bold"
                                    >
                                        {{ i.name }}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</nav>
